class TVoxyApp {
    token: string|null  = null
    name : string       = 'voxyapp'
    host : string       = ''

    constructor(name: string, host: string) {
        this.host = host
        this.name = name || 'voxyapp'
        this.readToken()
    }

    readToken() {
        this.token = null
        try {
            const token = sessionStorage.getItem(this.name+'_token')
            if(token && this.validToken(token)) this.token = token 
        } 
        catch (e) { console.error('Failed to read token:', e) }
    }

    writeToken(token: string) {
        try { 
            sessionStorage.setItem(this.name+'_token', token) 
            this.token = token
        }
        catch (e) { console.error('Failed to read token:', e) }
    }

    validToken(token: string|null = this.token) {
        var valid: boolean = false
        try {
            if(token) {
                const payload = JSON.parse(atob(token.split('.')[1]));
                if (payload.exp) {
                    const now = Math.floor(Date.now() / 1000);
                    valid = (payload.exp > now)
                    console.log('valid token', valid)
                }
            }
        } 
        catch(e) { console.error('Failed to read token:', e) }
        finally  { return valid }
    } 

    private getHeaders(): HeadersInit {
        return {
            'Accept': 'application/json',
            'x-api-key': this.token || ''
        }
    }

    async login(username: string, password: string): Promise<boolean> {
        var resp: boolean = false 
        try {
            var data = await this.get('/token', {username, password})
            if(data && data.token) {
                this.writeToken(data.token)
                resp = true
            }
        }
        catch(e) { console.error('error login :', e ) }
        finally  { return resp }
    }

    logout() {
        console.log('logging out..')
        this.token = null
        sessionStorage.removeItem(this.name+'_token')
        window.dispatchEvent(new CustomEvent('logout'))

    }

    loggedIn(): boolean {
        var resp = false 
        try { resp = this.validToken() }
        catch(e) { console.error('error checking login status', e) }
        finally  { return resp }
    }

    async get(uri: string, params?: Record<string, any>): Promise<any|null> {
        var resp: any|null = null
        try {
            var url = `${this.host}${uri}`
            const queryString = params ? '?' + new URLSearchParams(params as Record<string, string>).toString() : ''
            const response = await fetch(url + queryString, {
                method: 'GET',
                headers: this.getHeaders()
            })
            if (!response.ok) { throw new Error(`GET request failed with status ${response.status}`) }
            resp = await response.json()
        }
        catch(e) { console.error('error in GET', uri, ':', e) }
        finally  { return resp }
    }

    async post(uri: string, body: Record<string, any>): Promise<any|null> {
        var resp: any|null = null
        try {
            var url = `${this.host}${uri}`
            console.log('POST', url, body )
            const response = await fetch(url, {
                method: 'POST',
                headers: {...this.getHeaders(), 'Content-Type': 'application/json' },
                body: JSON.stringify(body),
            })
            if (!response.ok) { throw new Error(`POSt request failed with status ${response.status}`) }
            resp = await response.json()
        }
        catch(e) { console.error('error in GET', uri, ':', e) }
        finally  { return resp }
    }

    async delete(uri: string, params?: Record<string, any>): Promise<any|null> {
        var resp: any|null = null
        try {
            var url = `${this.host}${uri}`
            const queryString = params ? '?' + new URLSearchParams(params as Record<string, string>).toString() : '';
            const response = await fetch(url + queryString, {
                method: 'DELETE',
                headers: this.getHeaders()
            })
            if (!response.ok) { throw new Error(`GET request failed with status ${response.status}`) }
            resp = await response.json()
        }
        catch(e) { console.error('error in GET', uri, ':', e) }
        finally  { return resp }
    }
}

declare global {
    interface Window {
        voxyapp: TVoxyApp
    }
}
export function start(name: string, host: string) : TVoxyApp {
    window.voxyapp = window.voxyapp || new TVoxyApp(name, host)
    return window.voxyapp
}
